module.exports = __webpack_public_path__ + "static/media/cog.8db53187.svg";